<template>
    <div>
        <div class="page__head container">
            <div class="page__submenu  block">
                <div class="subnav">
                    <div class="subnav__item">
                        <a href="/profiles/settings/" class="subnav__link  link h4">Контактные данные</a>
                    </div>
                    <div class="subnav__item">
                        <a href="/profiles/personal/" class="subnav__link is-active link h4">Подключенные ЛС</a>
                    </div>
                    <!--<div class="subnav__item">
                        <a href="/profiles/settings/" class="subnav__link  link h4">Настройки профиля</a>
                    </div>-->
                </div>
                <a href="#" class="header-instruction link link--pseudo">
                    <div class="link__text">Инструкция</div>
                    <div class="header-instruction__icon link__icon fab-icon">
                        <i class="icon icon--help"></i>
                    </div>
                </a>
            </div>
            <div class="page__head-inner block">
                <!-- Для этой страницы стиль заголвока h2 -->
                <h1 class="page__title h2">Добавление лицевого счета</h1>
                <div class="page__descr page__descr--entity" style="width: 1100px;max-width:100%">
                    Уважаемый клиент, если Вам по какой-то причине не удалось добавить Лицевой счет, сообщите о проблеме в разделе 
                    <a href="/faq/add" target="_blank" rel="noopener">Задать вопрос</a>
                </div>
            </div>
        </div>

        <div class="page__main container">
            <div class="page__index block">
                <ul class="subnav subnav--underlined subnav--block" style="max-width: 1200px;">
                    <!--<li class="subnav__item">-->
                        <!--<a :href="'#adding_entity_11'" id="flLink1" class="subnav__link link h4" v-on:click="showFL()"   data-toggle="tab">Частный дом, квартира, комната, паркинг, кладовка</a>-->
                        <!--<div data-toggle="tab">Частный дом, квартира, комната, паркинг, кладовка</div>
                    </li>-->
                    <li class="subnav__item active">
                        <a :href="'#adding_entity_2'" id="ulLink" class="subnav__link  link h4" v-on:click="showUL()" data-toggle="tab">Нежилое помещение в МКД, отдельностоящее здание и т.д   </a>
                    </li>
                </ul>
                <div class="add-individual-form add-individual-form--block-offset">
                    <div class="b-form b-form--lg">
                        <!-- ФЛ -->
                        <form id="adding_entity_1" action="/" class="add-individual-form__inner js-form js-transition-inputs-container tab-content" style="display:none">
                            <div class="add-individual-form__item">
                                <label class="txt-input">
                                    <div class="txt-input__label">Фамилия владельца квитанции *</div>
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input req js-transition-input" type="text">
                                    </div>
                                </label>
                            </div>
                            <div class="add-individual-form__item">
                                <label class="txt-input">
                                    <div class="txt-input__label">Имя владельца квитанции *</div>
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input req js-transition-input" type="text">
                                    </div>
                                </label>
                            </div>
                            <div class="add-individual-form__item">
                                <label class="txt-input">
                                    <div class="txt-input__label">Отчество владельца квитанции</div>
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input js-transition-input" type="text">
                                    </div>
                                </label>
                            </div>
                            <div class="add-individual-form__item">
                                <div class="b-select fast-pay__lg-select city-select city-select--faq">
                                    <div class="city-select__label">Населенный пункт *</div>
                                    <div class="btn-group bootstrap-select b-select__picker">
                                        <!--<button type="button" class="button dropdown-toggle bs-placeholder" data-toggle="dropdown" role="button" title="Абакан">
                                        <span class="filter-option pull-left">Абакан</span>&nbsp;<span class="bs-caret"><span class="caret"></span>
                                              </span>
                                            </button>-->
                                        <div class="dropdown-menu open" role="combobox"><ul class="dropdown-menu inner" role="listbox" aria-expanded="false"><li data-original-index="0" class="selected"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true"><span class="text">Абакан</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="1"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Барнаул</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="2"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Белово</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="3"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Бийск</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="4"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Канск</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="5"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Кемерово</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="6"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Красноярск</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="7"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Куйбышев</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="8"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Минусинск</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="9"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Мыски</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="10"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Назарово</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="11"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Новокузнецк</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="12"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Новосибирск</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="13"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">Рубцовск</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li></ul></div>
                                        <select class="b-select__picker selectpicker" data-style="null" data-style-base="button" tabindex="-98">
                                            <option value="">Абакан</option>
                                            <option value="">Барнаул</option>
                                            <option value="">Белово</option>
                                            <option value="">Бийск</option>
                                            <option value="">Канск</option>
                                            <option value="">Кемерово</option>
                                            <option value="">Красноярск</option>
                                            <option value="">Куйбышев</option>
                                            <option value="">Минусинск</option>
                                            <option value="">Мыски</option>
                                            <option value="">Назарово</option>
                                            <option value="">Новокузнецк</option>
                                            <option value="">Новосибирск</option>
                                            <option value="">Рубцовск</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Улица *</div>
                                    <div class="btn-group bootstrap-select b-select__picker">
                                        <!--<button type="button" class="button dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button" title="1"><span class="filter-option pull-left">1</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span>
                                            </button>-->
                                        <div class="dropdown-menu open" role="combobox">
                                            <div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off" role="textbox" aria-label="Search"></div><ul class="dropdown-menu inner" role="listbox" aria-expanded="false"><li data-original-index="0" class="selected"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true"><span class="text">1</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="1"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">2</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="2"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">3</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li></ul>
                                        </div>
                                        <select class="b-select__picker selectpicker" data-style-base="button" data-live-search="true" tabindex="-98">
                                            <option value="">1</option>
                                            <option value="">2</option>
                                            <option value="">3</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Номер дома *</div>
                                    <div class="btn-group bootstrap-select b-select__picker">
                                        <!--<button type="button" class="button dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button" title="1"><span class="filter-option pull-left">1</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span>
                                            </button>-->
                                        <div class="dropdown-menu open" role="combobox"><div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off" role="textbox" aria-label="Search"></div><ul class="dropdown-menu inner" role="listbox" aria-expanded="false"><li data-original-index="0" class="selected"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true"><span class="text">1</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="1"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">2</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="2"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">3</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li></ul></div>
                                        <select class="b-select__picker selectpicker" data-style-base="button" data-live-search="true" tabindex="-98">
                                            <option value="">1</option>
                                            <option value="">2</option>
                                            <option value="">3</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="add-individual-form__item">
                                <div class="b-select">
                                    <div class="b-select__label">Номер квартиры *</div>
                                    <div class="btn-group bootstrap-select b-select__picker">
                                        <!--<button type="button" class="button dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button" title="1"><span class="filter-option pull-left">1</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span>
                                            </button>-->
                                        <div class="dropdown-menu open" role="combobox"><div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off" role="textbox" aria-label="Search"></div><ul class="dropdown-menu inner" role="listbox" aria-expanded="false"><li data-original-index="0" class="selected"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true"><span class="text">1</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="1"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">2</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="2"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">3</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li></ul></div>
                                        <select class="b-select__picker selectpicker" data-style-base="button" data-live-search="true" tabindex="-98">
                                            <option value="">1</option>
                                            <option value="">2</option>
                                            <option value="">3</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <!-- Если лицеаой счет найден -->
                            <div class="add-individual-form__item">
                                <label class="b-select">
                                    <div class="b-select__label">Номер лицевого счета</div>
                                    <div class="btn-group bootstrap-select b-select__picker">
                                        <!--<button type="button" class="button dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button" title="10419940441"><span class="filter-option pull-left">10419940441</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span>
                                            </button>-->
                                        <div class="dropdown-menu open" role="combobox"><ul class="dropdown-menu inner" role="listbox" aria-expanded="false"><li data-original-index="0" class="selected"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true"><span class="text">10419940441</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="1"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">29012932101</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li><li data-original-index="2"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false"><span class="text">91234843834</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li></ul></div>
                                        <select class="b-select__picker selectpicker" data-style-base="button" tabindex="-98">
                                            <option value="">10419940441</option>
                                            <option value="">29012932101</option>
                                            <option value="">91234843834</option>
                                        </select>
                                    </div>
                                </label>
                            </div>

                            <!-- Если лицеаой счет найден -->
                            <div class="add-individual-form__item">
                                <button type="submit" class="button button--th-main is-disable" data-submit="">
                                    <span class="button__text">Добавить ЛС</span>
                                </button>
                            </div>

                            <div class="add-individual-form__item add-individual-form__item--top-offset add-individual-form__item--full add-individual-form__item--right">
                                <label class="cb-input add-individual-form__check">
                                    <input id="agreementCheckbox" class="cb-input__checkbox req" type="checkbox">
                                    <span class="cb-input__check"></span>
                                    <span class="cb-input__label">Я принимаю <a href="" target="_blank" class="link link--present">«Правила пользования системой»</a></span>
                                </label>
                            </div>

                            <!-- Если лицеаой счет НЕ найден -->
                            <div class="add-individual-form__item add-individual-form__item--full add-individual-form__item--top-offset alert alert--info">
                                Сообщение: Мы не нашли ЛС по&nbsp;заданным параметрам <br>
                                <a href="" class="link link--underline link--primary"><span class="link__text">написать в поддержку</span></a>
                            </div>
                        </form>

                        <!-- ЮЛ -->
                        <form id="adding_entity_2" action="/" class="js-form js-timer-container tab-content" style="display:block">
                            <div class="password-recovery__steps add-entity-steps" style="--gap:20px; margin-top:20px;margin-bottom:36px">
                                <a id="step1" href="#adding_entity_step_1" class="password-recovery__steps-item js-step-link password-recovery__steps-item--active" data-toggle="tab">1</a>
                                <a id="step2" href="#adding_entity_step_2" class="password-recovery__steps-item js-step-link" data-toggle="tab">2</a>
                                <a id="step3" href="#adding_entity_step_3" class="password-recovery__steps-item js-step-link" data-toggle="tab">3</a>
                                <a id="step4" href="#adding_entity_step_4" class="password-recovery__steps-item js-step-link" data-toggle="tab">4</a>
                                <a id="step5" href="#adding_entity_step_5" class="password-recovery__steps-item js-step-link" data-toggle="tab">5</a>
                                <a id="step6" href="#adding_entity_step_6" class="password-recovery__steps-item js-step-link" data-toggle="tab">6</a>
                            </div>
                            <div class="add-entity-steps-inner js-show-blocks-container">
                                <div id="adding_entity_step_1" class="add-entity-row add-entity-row--first js-line-form js-tab-content">
                                    <div class="add-entity-row__inner" style="border-width:1px; padding-bottom:32px">
                                        <div class="add-entity-row__title">
                                            Укажите город и номер лицевого счета
                                            <div class="help">
                                                <div class="help__icon fab-icon" data-toggle="dropdown">
                                                    <i class="icon icon--help"></i>
                                                </div>
                                                <div class="help__drop">
                                                    <div class="help__inner">Выберите Ваш город из списка и укажите номер Вашего Лицевого Счёта</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="add-entity-row__right" style="margin-left:auto;display:flex">
                                            <div class="add-entity-row__item" style="width:220px">
                                                <div class="b-select fast-pay__lg-select city-select city-select--faq">
                                                    <div class="btn-group bootstrap-select b-select__picker">
                                                        <select class="b-select__picker selectpicker" data-style="null" data-style-base="button" tabindex="-98"
                                                                v-on:change="findAccountButtonAction();changeCity(cityId);"
                                                                title="выберите город" v-model="cityId">
                                                            <option v-for="city in Cities" v-bind:value="city.Id">{{ city.Name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-entity-row__item" style="width:220px; margin-left:20px">
                                                <label class="txt-input" aria-label="Введите ЛС">
                                                    <div class="txt-input__input">
                                                        <input class="txt-input__field input req" type="text"
                                                               v-on:change="findAccountButtonAction()"
                                                               v-on:input="findAccountButtonAction()"
                                                               v-bind:maxlength="maxLengthAccount"
                                                               placeholder="введите ЛС"
                                                               id="inputAccount"
                                                               v-model="inputAccountNumber">
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="add-entity-row__item add-entity-row__item--btn" style="margin-left:20px">
                                                <a v-if="isPhoneVerified != 1 && isEmailVerified!=1" href="#adding_entity_step_2" id="findAccountButton" class="button button--th-ctrl js-step-trigger js-hidden-block"
                                                   v-on:click="findAccounts()" data-toggle="tab" data-submit="">
                                                    <span class="button__text">Поиск</span>
                                                </a>
                                                <button v-if="isPhoneVerified == 1 || isEmailVerified==1" type="submit"
                                                        style="margin-left:20px"
                                                        class="button button--th-main js-shown-block js-disabled-button"
                                                        v-on:click="addAccount()"
                                                        data-submit="">
                                                    <span class="button__text">Добавить ЛС</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="adding_entity_step_2" class="add-entity-row js-line-form" style="display: none;">
                                    <div class="add-entity-row__inner" style="border-width:1px; padding-bottom:32px">
                                        <div class="add-entity-row__title">
                                            Введите ИНН
                                            <div class="help">
                                                <div class="help__icon fab-icon" data-toggle="dropdown">
                                                    <i class="icon icon--help"></i>
                                                </div>
                                                <div class="help__drop">
                                                    <div class="help__inner">Введите ИНН юридического лица или ИП</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="add-entity-row__right" style="margin-left:auto;display:flex">
                                            <div class="add-entity-row__item" style="width:220px">
                                                <label class="txt-input" aria-label="Введите ИНН">
                                                    <div class="txt-input__input">
                                                        <input class="txt-input__field input req" name="inn" maxlength="12" minlength="10"
                                                               v-on:change="checkInnButtonAction()"
                                                               v-on:input="checkInnButtonAction()"
                                                               data-mask-info-number="" data-type="inn" placeholder="введите ИНН"
                                                               id="inputINN"
                                                               v-model="inputContragentInn">
                                                        <div class="txt-input__required txt-input__required--error">ИНН не менее 10 и не более 12 знаков</div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="add-entity-row__item add-entity-row__item--btn" style="margin-left:20px">
                                                <a href="#adding_entity_step_3" id="checkInnButton" class="button button--th-ctrl js-step-trigger is-disable"
                                                   v-on:click="checkInn()"
                                                   data-toggle="tab" data-submit="">
                                                    <span class="button__text">Ок</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="adding_entity_step_3" class="add-entity-row js-tab-content tab-content js-line-form" style="display: none;">
                                    <div class="add-entity-row__inner" style="border-width:1px; padding-bottom:32px">
                                        <div class="add-entity-row__title">
                                            Введите один из адресов объектов на данном ЛС
                                            <div class="help">
                                                <div class="help__icon fab-icon" data-toggle="dropdown">
                                                    <i class="icon icon--help"></i>
                                                </div>
                                                <div class="help__drop">
                                                    <div class="help__inner">Введите адрес любого объекта из Вашего Лицевого Счёта</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="add-entity-row__right" style="margin-left:auto;display:flex">
                                            <div class="add-entity-row__item" style="width:220px">
                                                <div class="b-select fast-pay__lg-select">
                                                    <div class="btn-group bootstrap-select b-select__picker">
                                                        <select class="b-select__picker selectpicker"
                                                                data-style-base="button"
                                                                data-live-search="true"
                                                                v-on:change="changeItemStreet($event)"
                                                                id="streets" data-size="7">
                                                            <option disabled>Нет улиц для выбора</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-entity-row__item" style="width:220px; margin-left:20px">
                                                <div class="b-select">
                                                    <div class="btn-group bootstrap-select b-select__picker">
                                                        <select class="b-select__picker selectpicker"
                                                                data-style-base="button"
                                                                data-live-search="true"
                                                                v-on:change="changeItemHouse($event)"
                                                                data-none-selected-text="Ничего не выбрано"
                                                                id="houses" data-size="7"></select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-entity-row__item add-entity-row__item--btn" style="margin-left:20px">
                                                <a href="#adding_entity_step_4" class="button button--th-ctrl js-step-trigger"
                                                   v-on:click="compareSelectedAdress()"
                                                   data-toggle="tab">
                                                    <span class="button__text">Ок</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="adding_entity_step_4" class="js-tab-content tab-content js-line-form" style="display: none;">
                                    <div class="add-entity-row__inner add-entity-row__inner--block">
                                        <!--<div class="add-entity-row add-entity-row--inner">
                    <div class="add-entity-row__title">
                        <p>Укажите дату и номер любой счёт-фактуры за последний месяц</p>
                        <div class="help">
                            <div class="help__icon fab-icon" data-toggle="dropdown">
                                <i class="icon icon--help"></i>
                            </div>
                            <div class="help__drop">
                                <div class="help__inner">Подсказка</div>
                            </div>
                        </div>
                    </div>
                    <div class="add-entity-row__right js-block-form is-hide">
                        <div class="add-entity-row__item">
                            <label class="txt-input" aria-label="Введите ЛС">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input req" type="text" placeholder="Введите номер счёт-фактуры">
                                </div>
                            </label>
                        </div>
                        <div class="add-entity-row__item">
                            <label class="txt-input" aria-label="Выберите период">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input js-period-picker-days-year req" type="text" placeholder="Выберите период">
                                    <div class="txt-input__icon fab-icon">
                                        <i class="icon icon--calendar"></i>
                                    </div>
                                </div>
                            </label>
                        </div>
                        <div class="add-entity-row__item add-entity-row__item--btn">
                            <a href="#adding_entity_step_1" class="button button--th-ctrl js-step-trigger js-show-block-trigger"
                               data-toggle="tab"
                               data-submit="">
                                <span class="button__text">Ок</span>
                            </a>
                        </div>
                    </div>
                </div>-->
                                        <!--<div class="add-entity-row add-entity-row--inner text-bold">ИЛИ</div>-->
                                        <div class="add-entity-row add-entity-row--inner" style="border-width:1px; padding-bottom:32px">
                                            <div class="add-entity-row__title">
                                                Подтвердите через sms/email код по данным контактам
                                                <div class="help">
                                                    <div class="help__icon fab-icon" data-toggle="dropdown">
                                                        <i class="icon icon--help"></i>
                                                    </div>
                                                    <div class="help__drop">
                                                        <div class="help__inner">Выберите способ направления кода для подтверждения (телефон или е-мэйл). Это основные контакты по Вашему договору поставки</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="add-entity-row__right" style="margin-left:auto;display:flex">
                                                <div class="add-entity-row__item" style="width:300px;" id="checkPhone">
                                                    <a href="#adding_entity_step_5" class="input-tab__text js-step-trigger"
                                                       v-on:click="checkFindPhone=true; stepHide(4);stepShow(5);"
                                                       data-toggle="tab">
                                                        <span class="input-tab__text-label">Телефон:</span>
                                                        <span class="status-primary">{{findPhoneHide}}</span>
                                                    </a>
                                                </div>
                                                <div class="add-entity-row__item" style="width:340px; margin-left:20px" id="checkEmail">
                                                    <a href="#adding_entity_step_5" class="input-tab__text js-step-trigger"
                                                       v-on:click="checkFindEmail=true; stepHide(4);stepShow(5);"
                                                       data-toggle="tab">
                                                        <span class="input-tab__text-label">E-mail:</span>
                                                        <span class="status-primary">{{findEmailHide}}</span>
                                                    </a>
                                                </div>
                                                <div class="add-entity-row__item add-entity-row__item--btn" style="margin-left:20px"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="adding_entity_step_5" class="add-entity-row js-tab-content tab-content js-line-form" style="display: none;">
                                    <div class="add-entity-row__inner" style="border-width:1px; padding-bottom:32px">
                                        <div class="add-entity-row__title">
                                            Введите код с картинки
                                            <div class="help">
                                                <div class="help__icon fab-icon" data-toggle="dropdown">
                                                    <i class="icon icon--help"></i>
                                                </div>
                                                <div class="help__drop">
                                                    <div class="help__inner">Введите код с картинки и нажмите ОК. После двух неверных попыток код будет изменён</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="add-entity-row__right" style="margin-left:auto;display:flex">
                                            <div class="add-entity-row__item capcha-image js-capcha-image" style="width:220px;" id="captchaImage">
                                                <!--<img src="/images/capcha.png">-->
                                                <img src="/Profiles/Captcha">
                                            </div>
                                            <!--<div id="captcha1" class="register-form__row-half-item capcha-image js-capcha-image">
                        <img src="/Captcha/Index">
                    </div>-->
                                            <div class="add-entity-row__item" style="width:220px; margin-left:20px">
                                                <label class="txt-input__input" aria-label="Введите код">
                                                    <input type="text" class="txt-input__field input" placeholder="введите код"
                                                           v-on:change="checkCaptchaButtonAction()"
                                                           v-on:input="checkCaptchaButtonAction()"
                                                           id="checkCaptcha"
                                                           maxlength="8"
                                                           v-model="inputCapchaCode">
                                                    <div class="txt-input__required--success" v-if="checkCapchaCode">Код введен верно</div>
                                                    <div class="txt-input__required--error" v-if="!checkCapchaCode">{{capchaError}}</div>
                                                </label>
                                            </div>
                                            <div class="add-entity-row__item add-entity-row__item--btn" style="margin-left:20px">
                                                <a href="#adding_entity_step_6" class="button button--th-ctrl js-step-trigger js-poison-code is-disable"
                                                   id="checkCaptchaButton"
                                                   v-on:click="checkCaptcha"
                                                   data-toggle="tab" data-submit="">
                                                    <span class="button__text">Ок</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="adding_entity_step_6" class="add-entity-row js-tab-content tab-content js-line-form" style="display: none;">
                                    <div class="add-entity-row__inner" style="border-width:1px; padding-bottom:32px">
                                        <div class="add-entity-row__title">
                                            Введите код подтверждения
                                            <div class="help">
                                                <div class="help__icon fab-icon" data-toggle="dropdown">
                                                    <i class="icon icon--help"></i>
                                                </div>
                                                <div class="help__drop">
                                                    <div class="help__inner">Введите полученный код подтверждения, направленный Вам на телефон или е-мэйл</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="add-entity-row__right" style="margin-left:auto;display:flex">
                                            <div class="add-entity-row__item" style="width:220px;">
                                                <label class="txt-input__input" aria-label="Введите код">
                                                    <input type="text" class="txt-input__field input" placeholder="введите код"
                                                           v-on:change="checkVerifyCodeButtonAction()"
                                                           v-on:input="checkVerifyCodeButtonAction()"
                                                           id="inputVerifyCode"
                                                           maxlength="8"
                                                           v-model="inputCode">
                                                    <div class="txt-input__required txt-input__required--error txt-input__required--dbl"
                                                         v-if="isPhoneVerified==-1 || isEmailVerified==-1">Код введен неверно</div>
                                                </label>
                                            </div>
                                            <div class="add-entity-row__item add-entity-row__item--btn timer-container-sm" style="margin-left:20px">
                                                <a href="#adding_entity_step_1"
                                                   class="button button--th-main timer-container-sm__btn js-poison-code-submit js-show-block-trigger is-disable"
                                                   v-on:click="verifyCheckCode"
                                                   id="checkVerifyCodeButton"
                                                   data-toggle="tab" data-submit="">
                                                    OK
                                                    <span class="form-timer form-timer--light js-timer">
                                                        <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                            <path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
															M 50, 50
															m -45, 0
															a 45,45 0 1,0 90,0
															a 45,45 0 1,0 -90,0
															"></path>
                                                        </svg>
                                                        <span class="js-timer-count form-timer__count">
                                                        </span>
                                                    </span>
                                                </a>
                                                <button type="button" class="button button--th-main js-poison-code js-poison-code-again"
                                                        v-on:click="verifyStart"
                                                        style="display: none;">
                                                    Отправить<br>еще раз
                                                </button>
                                                <div class="js-success-message alert alert--sm alert--success" v-if="isPhoneVerified==1">
                                                    Телефон подтвержден
                                                </div>
                                                <div class="js-success-message alert alert--sm alert--success" v-if="isEmailVerified==1">
                                                    Email подтвержден
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="showNotFindMessage" class="add-individual-form__item--top-offset alert alert--info">
                                Такой лицевой счёт в выбранном городе не найден
                                <!--<a href="" class="link link--underline link--primary"><span class="link__text">Написать в поддержку</span></a>-->
                            </div>
                            <div v-if="showNotFindContacts" class="add-individual-form__item--top-offset alert alert--info">
                                Введены неверные данные, необходимо проверить информацию в договоре или сообщите о проблеме в разделе
                                <a href="/faq/add" class="card-promo__button button button--th-ctrl">Задать вопрос</a>
                                <!--Контактные данные не найдены. Обратитесь в <a href="/UL/helpinfo/kontakty-i-adresa-cok#contactSection_3">ЦОК</a>-->
                            </div>
                            <div v-if="showIncorrectMessage" class="add-individual-form__item--top-offset alert alert--info">
                                Введены неверные данные, необходимо проверить информацию в договоре или сообщите о проблеме в разделе
                                <a href="/faq/add" class="card-promo__button button button--th-ctrl">Задать вопрос</a>
                                <!--<a href="" class="link link--underline link--primary"><span class="link__text">Написать в поддержку</span></a>-->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import ProfilesHeader from './ProfilesHeader.vue';

    export default {
        name: 'add-entity',
        props: ['cities'],
        data: function () {
            return {
                settings: {
                    name: 'personal',
                    isAddAccount: true,
                    addAccountHeader: 'Добавление лицевого счета юридического лица'
                },
                login: '',
                password: '',
                isChecking: false,
                responseStatus: false,
                responseError: '',
                accounts: [],
                selectedAccounts: [],
                accountForAdd: {},

                maxLengthAccount: 16,
                lenAccountCityId_1: [3, 5, 6, 7, 8, 10, 11, 13], //Новосибирск
                lenAccountCityId_2: [10, 12], //Красноярск
                lenAccountCityId_3: [1, 2, 3, 4, 5, 6, 7, 8, 10], //Кемерово
                lenAccountCityId_4: [12], //Абакан
                lenAccountCityId_5: [8, 9, 10], //Белово
                lenAccountCityId_6: [10], //Канск
                lenAccountCityId_7: [10], //Минусинск
                lenAccountCityId_8: [10], //Назарово
                lenAccountCityId_9: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 14], //Барнаул
                lenAccountCityId_10: [1, 3, 5, 6, 7, 8, 10], //Бийск
                lenAccountCityId_11: [5, 6, 7, 10], //Куйбышев
                lenAccountCityId_12: [1, 2, 4, 5, 6], //Мыски
                lenAccountCityId_13: [2, 4, 5, 6, 7, 8], //Новокузнецк
                lenAccountCityId_14: [1, 2, 3, 4, 5], //Рубцовск
                lenAccountCityId_20: [10], //Черногорск
                lenAccountCityId_24: [1, 2, 3, 4], //Лучегорск
                lenAccountCityId_25: [1, 2, 3, 4], //Кызыл
                lenAccountCityId_26: [13], //Ковдор
                lenAccountCityId_45: [1, 2, 3], //Рефтинский

                Cities: [],
                addresses: { legalAccountAdresses: [] },
                contacts: { phone: "", email: "", legalAccountPhones: [], legalAccountEmails: [] },
                countCheck: 1,
                cityId: 0,
                cityGuid: "",
                selectedSreetName: "",
                selectedSreetGuid: "",
                selectedHouseName: "",
                selectedHouseGuid: "",
                inputAccountNumber: "",
                inputContragentInn: "",
                inputCapchaCode: "",
                checkCapchaCode: false,
                capchaError: "",
                findAccountNumber: "",
                findContragentInn: "",
                findPhone: "",
                findEmail: "",
                findPhone1: "",
                findEmail1: "",
				findPhoneHide: "",
				findEmailHide: "",
                checkFindPhone: false,
                checkFindEmail: false,
                findInputAddress: false,
                failedAttempts1: 0,
                failedAttempts2: 0,
                failedAttempts3: 0,
                failedAttempts4: 0,
                failedAttempts5: 0,
                failedAttempts6: 0,
                activeStep2: false,
                activeStep3: false,
                activeStep4: false,
                activeStep5: false,
                activeStep6: false,

                /// верификация телефона
                phoneVerifyError: '',
                isPhoneVerified: 0,
                phoneCode: '',
                /// верификация email
                emailVerifyError: '',
                isEmailVerified: 0,
                emailCode: '',
                inputCode: '',

				showNotFindContacts: false,
                showNotFindMessage: false,
                showIncorrectMessage: false

            }
        },
        components: {
            'app-header': ProfilesHeader,
        },
        filters: {
            formatDate(value) {
                if (value)
                    return moment(value).format('DD.MM.YYYY');

                return "";
            }
        },
        computed: {
            getStatusClass() {
                return this.isChecking ? 'is-overlay' : ''
            },
            getButtonClass() {
                return !this.password || !this.login ? 'disabled' : ''
            },
            getDisabledClass() {
                return this.selectedAccounts.length > 0 ? '' : 'disabled'
            },
            checkAll: {
                get: function () {
                    return this.accounts ? this.selectedAccounts.length == this.accounts.length : false;
                },
                set: function (value) {
                    var self = this
                    var selected = [];

                    if (value && this.accounts) {
                        self.accounts.forEach(function (acc) {
                            selected.push(acc);
                        });
                    }

                    this.selectedAccounts = selected;
                }
            }
        },
        methods: {

            showFL: function () {
                var flId = document.getElementById('adding_entity_1');
                var ulId = document.getElementById('adding_entity_2');
                if (flId != undefined) flId.style.display = 'flex';
                if (ulId != undefined) ulId.style.display = 'none';

                var flLink = document.getElementById('flLink');
                var ulLink = document.getElementById('ulLink');
                if (flLink != undefined) $(flLink).addClass('active');
                if (ulLink != undefined) $(ulLink).removeClass('active');

            },

            showUL: function () {
               // var flId = document.getElementById('adding_entity_1');
                var ulId = document.getElementById('adding_entity_2');
               // if (flId != undefined) flId.style.display = 'none';
                if (ulId != undefined) ulId.style.display = 'block';
              //  var flLink = document.getElementById('flLink');
                var ulLink = document.getElementById('ulLink');
              //  if (flLink != undefined) $(flLink).removeClass('active');
                if (ulLink != undefined) $(ulLink).addClass('active');
                $('#inputAccount').mask("9999999999999999");
                $('#inputINN').mask("999999999999");
            },    

            findAccountButtonAction: function () {
                this.showNotFindMessage = false;
                this.showIncorrectMessage = false;
                this.showNotFindContacts = false;
                this.deActiveSteps(2);
                var findButton = document.getElementById('findAccountButton');
                if (findButton != undefined) {
                    $(findButton).addClass('is-disable');
                    if (this.cityId > 0) {
                        // this.maxLengthAccount = this.getMaxLenAccountByCityId(this.cityId);
                        if (this.checkValidLenAccountByCityId(this.inputAccountNumber, this.cityId) == true) $(findButton).removeClass('is-disable');
                    }
                }
            },

            changeCity: function (cityId) {
                this.inputAccountNumber = "";
                this.maxLengthAccount = this.getMaxLenAccountByCityId(cityId);
            },

            checkValidLenAccountByCityId: function (inputAccount, cityId) {
                var isValidLen = false;
                var lenAccount = inputAccount.length;
                switch (cityId) {
                    case 1://Новосибирск
                        if (this.lenAccountCityId_1.includes(lenAccount)) isValidLen = true;
                        break;
                    case 2:
                        if (this.lenAccountCityId_2.includes(lenAccount)) isValidLen = true;
                        break;
                    case 3:
                        if (this.lenAccountCityId_3.includes(lenAccount)) isValidLen = true;
                        break;
                    case 4:
                        if (this.lenAccountCityId_4.includes(lenAccount)) isValidLen = true;
                        break;
                    case 5:
                        if (this.lenAccountCityId_5.includes(lenAccount)) isValidLen = true;
                        break;
                    case 6:
                        if (this.lenAccountCityId_6.includes(lenAccount)) isValidLen = true;
                        break;
                    case 7:
                        if (this.lenAccountCityId_7.includes(lenAccount)) isValidLen = true;
                        break;
                    case 8:
                        if (this.lenAccountCityId_8.includes(lenAccount)) isValidLen = true;
                        break;
                    case 9:
                        if (this.lenAccountCityId_9.includes(lenAccount)) isValidLen = true;
                        break;
                    case 10:
                        if (this.lenAccountCityId_10.includes(lenAccount)) isValidLen = true;
                        break;
                    case 11:
                        if (this.lenAccountCityId_11.includes(lenAccount)) isValidLen = true;
                        break;
                    case 12:
                        if (this.lenAccountCityId_12.includes(lenAccount)) isValidLen = true;
                        break;
                    case 13:
                        if (this.lenAccountCityId_13.includes(lenAccount)) isValidLen = true;
                        break;
                    case 14:
                        if (this.lenAccountCityId_14.includes(lenAccount)) isValidLen = true;
                        break;
                    case 20:
                        if (this.lenAccountCityId_20.includes(lenAccount)) isValidLen = true;
                        break;
                    case 24:
                        if (this.lenAccountCityId_24.includes(lenAccount)) isValidLen = true;
                        break;
                    case 25:
                        if (this.lenAccountCityId_25.includes(lenAccount)) isValidLen = true;
                        break;
                    case 26:
                        if (this.lenAccountCityId_26.includes(lenAccount)) isValidLen = true;
                        break;
                    case 45:
                        if (this.lenAccountCityId_45.includes(lenAccount)) isValidLen = true;
                        break;
                    default:
                        isValidLen = false;
                        break;
                }
                return isValidLen;
            },

            getMaxLenAccountByCityId: function (cityId) {
                var lenAccount = 0;
                let arr = [];
                switch (cityId) {
                    case 1://Новосибирск
                        arr = this.lenAccountCityId_1.slice();
                        break;
                    case 2:
                        arr = this.lenAccountCityId_2.slice();
                        break;
                    case 3:
                        arr = this.lenAccountCityId_3.slice();
                        break;
                    case 4:
                        arr = this.lenAccountCityId_4.slice();
                        break;
                    case 5:
                        arr = this.lenAccountCityId_5.slice();
                        break;
                    case 6:
                        arr = this.lenAccountCityId_6.slice();
                        break;
                    case 7:
                        arr = this.lenAccountCityId_7.slice();
                        break;
                    case 8:
                        arr = this.lenAccountCityId_8.slice();
                        break;
                    case 9:
                        arr = this.lenAccountCityId_9.slice();
                        break;
                    case 10:
                        arr = this.lenAccountCityId_10.slice();
                        break;
                    case 11:
                        arr = this.lenAccountCityId_11.slice();
                        break;
                    case 12:
                        arr = this.lenAccountCityId_12.slice();
                        break;
                    case 13:
                        arr = this.lenAccountCityId_13.slice();
                        break;
                    case 14:
                        arr = this.lenAccountCityId_14.slice();
                        break;
                    case 20:
                        arr = this.lenAccountCityId_20.slice();
                        break;
                    case 24:
                        arr = this.lenAccountCityId_24.slice();
                        break;
                    case 25:
                        arr = this.lenAccountCityId_25.slice();
                        break;
                    case 26:
                        arr = this.lenAccountCityId_26.slice();
                        break;
                    case 45:
                        arr = this.lenAccountCityId_45.slice();
                        break;
                    default:
                        break;
                }
                lenAccount = arr.slice(-1);
                return lenAccount;
            },

            checkCaptchaButtonAction: function () {
                this.showIncorrectMessage = false;
                this.showNotFindMessage = false;
                this.showNotFindContacts = false;
                this.deActiveSteps(6);
                var checkCaptchaButton = document.getElementById('checkCaptchaButton');
                if (checkCaptchaButton != undefined) {
                    checkCaptchaButton.style.display = 'block';
                    $(checkCaptchaButton).addClass('is-disable');
                    if (this.inputCapchaCode.length > 5) $(checkCaptchaButton).removeClass('is-disable');
                }
            },

            changeItemStreet: function (event) {
                //this.$forceUpdate();
                //console.info("changeItemStreet");
                //console.info(this.cityId(), this.bspId());
                this.selectedSreetGuid = $("#streets").val();
                this.selectedSreetName = $('#streets option:selected').text();
                this.getHousesByStreet();
            },
            changeItemHouse: function (event) {
                //this.$forceUpdate();
                //console.info("changeItemHouse");
                //console.info(this.cityId(), this.bspId());
                this.selectedHouseGuid = $("#houses").val();
                this.selectedHouseName = $('#houses option:selected').text();
                //this.compareSelectedAdress();
            },

            compareSelectedAdress: function () {
                this.findInputAddress = false;
                this.showIncorrectMessage = false;
                this.showNotFindMessage = false;
                this.showNotFindContacts = false;
                //           if (this.streetId() == undefined || this.houseId() == undefined) {
                //return;
                //           }
                if (this.selectedSreetName == "" || this.selectedHouseName == "") {
                    return
                }

                this.selectedSreetName = $('#streets option:selected').text();
                //var svalue = $('#streets').val();
                //            var sselectedIndex = $('#streets option:selected').index();
                this.selectedHouseName = $('#houses option:selected').text();
                //var hvalue = $('#houses').val();
                //var hselectedIndex = $('#houses option:selected').index();

                let splitStreet = this.selectedSreetName.split(' ');
                let findStreet = splitStreet[0];
                if (splitStreet.length > 0) { findStreet = splitStreet[1]; }
                var devAdresses = this.addresses.legalAccountAdresses;
                if (devAdresses != undefined && devAdresses != null) {
                    for (var i = 0; i < devAdresses.length; i++) {
                        if (devAdresses[i].includes(findStreet) == true && devAdresses[i].includes(this.selectedHouseName) == true) {
                            this.findInputAddress = true;
                            console.log('Введенный адрес присутствует среди найденных на ЛС адресов');
                            this.activeStep4 = true;
                            this.stepActive(4);
                            this.stepHide(5);
                            this.noErrorAddress();
                            //this.findContacts();
                            this.findContacts1();
                            break;
                        }
                    }
                }
                if (this.findInputAddress == false) {
                    console.log('Найденные на ЛС адреса и введенный адрес не совпадают');
                    this.activeStep4 = false;
                    this.showIncorrectMessage = true;
                    this.deActiveSteps(4);
                    this.failedAttempts3 = this.failedAttempts3 + 1;
                    this.errorAddress();
                }
            },

            getRandomInt: function (min, max) {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min) + min);
            },

            checkCaptcha: function (event) {
                event.stopPropagation();

                console.log("checkCaptcha");

                const self = this;
                this.checkCapchaCode = false;
                this.capchaError = "";
                //const hiddenBlock = document.querySelector('.js-capcha-hidden-block'); // Кнопка отправить проверочный код
                //const showCapchaContainer = document.querySelector('.js-capcha-show-container'); // Блок капчи
                //const nextTrigger = document.querySelector('.js-capcha-next-trigger');
                //const input = document.querySelector('.js-capcha-input');
                //const image = document.querySelector('.js-capcha-image');
                var count = this.getRandomInt(0, 100);

                axios.post('/Register/CheckCaptcha/' + self.inputCapchaCode)
                    .then(function (response) {
                        console.info('checkCaptcha', response);
                        if (response.data.isSuccess) {
                            //hiddenBlock.style.display = '';
                            //showCapchaContainer.style.display = 'none';
                        }
                        if (!response.data.isSuccess) {
                            var countch = self.countCheck++;
                            console.log("Count Check", countch);
                            //$("#captcha1").load(" #captcha1 > *");
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.checkCapchaCode = false;
                            self.capchaError = "Код введен неверно";
                            self.activeStep6 = false;
                            //self.showIncorrectMessage = true;
                            self.deActiveSteps(6);
                            self.failedAttempts5 = self.failedAttempts5 + 1;
                            self.errorCaptcha();

                            //self.phoneVerifyError = response.data.message.join('');
                            /*	$("#phone").prop('disabled', '');*/

                            if (countch % 2 === 0) {
                                var str = '<img src="/Profiles/Captcha/' + count + '">';
                                console.log("String", str);
                                $("#captchaImage").html(str);
                            }
                            //nextTrigger.style.display = 'none';
                            //image.style.display = '';
                            //input.classList.add('is-error');
                        }
                        else {
                            self.checkCapchaCode = true;
                            self.capchaError = "";
                            self.activeStep6 = true;
                            self.stepActive(6);
                            self.stepHide(5);
                            self.showIncorrectMessage = false;
                            self.showNotFindMessage = false;
                            self.showNotFindContacts = false;
                            self.noErrorCaptcha();
                            self.verifyStart(event);
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        //self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
                        //$("#phone").prop('disabled', '');
                    });
            },

            phoneHide: function (phone) {
                var result = phone;
                if (phone.length == 11) {
                    result = "+" + phone.substring(0, 2) + "**-" + phone.substring(4, 5) + "**-*" + phone.substring(8, 9) + "-" + phone.substring(9, 11);
                }
                return result;
            },

			emailHide: function (email) {
                var result = email;
                var lenEmail = email.length;
                if (lenEmail > 6) {
                    var parts = email.split('@');
                    var lenPart0 = parts[0].length;
                    var lenPart1 = parts[1].length;

                    var parts1 = parts[1].split('.');
					var lenPart10 = parts1[0].length;

					result = parts[0].substring(0, 1) + this.hideSymbols(lenPart0 - 2) + parts[0].substring(lenPart0 - 1, lenPart0) + "@"
						+ parts1[0].substring(0, 1) + this.hideSymbols(lenPart10 - 2) + parts1[0].substring(lenPart10 - 1, lenPart10) + "." + parts1[1];
				}
				return result;
            },

			hideSymbols: function (count) {
				var str = "";
				for (var i = 0; i < count; i++) {
					str = str + "*";
				}
				return str;
			},

            phonesCheck: function (phonesStr) {
                var result = "";

                var phones = phonesStr.split(',');
                if (phones.length > 0) {
                    for (var i = 0; i < phones.length; i++) {
                        var curPhone = phones[i].trim().replace("-", "").replace("+", "").replace("(", "").replace(")", "").replace(" ", "");
                        if (curPhone.length >= 10) {
                            curPhone = curPhone.substring(curPhone.length - 10);
                            var firstDigit = curPhone.substring(0, 1);
                            if (firstDigit == "9") {
                                result = "7" + curPhone;
                                break;
                            }
                        }
                    }

                }
                return result;
            },

            findContacts1: function () {
                if (this.findPhone1 !== "") {
                    this.findPhone = this.phonesCheck(this.findPhone1);
					this.findPhoneHide = this.phoneHide(this.findPhone);
                }
                if (this.findEmail1 !== "") {
                    this.findEmail = this.findEmail1;
					this.findEmailHide = this.emailHide(this.findEmail);
                }
                if (this.findPhone == "" && this.findEmail == "") {
                    console.log('Не найдено контактов на ЛС');
					this.showNotFindContacts = true;
                    this.activeStep5 = false;
                    this.deActiveSteps(5);
                    this.failedAttempts4 = this.failedAttempts4 + 1;
                }
                else {
                    this.showIncorrectMessage = false;
                    this.showNotFindMessage = false;
                    this.showNotFindContacts = false;
                    this.activeStep5 = true;
                    this.stepActive(5);
                }
            },

            findContacts: function () {
                var self = this

                self.responseStatus = false
                self.responseError = ''
                //self.contacts = []
                self.checkFindPhone = false;
                self.checkFindEmail = false;

                axios.post('/Profiles/FindAccountsContacts', {
                    DatabaseId: self.accounts[0].databaseId,
                    DivisionId: self.accounts[0].divisionId,
                    AccountId: self.accounts[0].accountId,
                    AccountNumber: self.accounts[0].accountNumber,
                    SAPDatabaseId: self.accounts[0].sapDatabaseId,
                    SAPDivisionId: self.accounts[0].sapDivisionId,
                    SAPAccountId: self.accounts[0].sapAccountId,
                    SAPAccountNumber: self.accounts[0].sapAccountNumber
                })
                    .then(function (response) {
                        self.responseStatus = response.data.success;
                        self.responseError = response.data.responseError;

                        if (response.data.success) {
                            self.contacts = response.data.data
                            //console.log(self.contacts);
                            //console.log(self.contacts);

                            if (self.contacts != null) {
                                //self.findContragentInn = self.accounts[0].contragentInn;
                              //  console.log('Найденный телефон на ЛС: ' + self.contacts.phone);
                              //  console.log('Найденный емэйл на ЛС: ' + self.contacts.email);
                                self.findPhone = self.contacts.phone;
                                self.findEmail = self.contacts.email;
								if (self.findPhone !== "") {
									self.findPhone = self.phonesCheck(self.findPhone);
									self.findPhoneHide = self.phoneHide(self.findPhone);
								}
								if (self.findEmail !== "") {
									self.findEmail = self.findEmail;
									self.findEmailHide = self.emailHide(self.findEmail);
								}
                                if (self.findPhone == "" && self.findEmail == "") {
                                    console.log('Не найдено контактов на ЛС');
									self.showNotFindContacts = true;
                                    self.activeStep5 = false;
                                    self.deActiveSteps(5);
                                    self.failedAttempts4 = self.failedAttempts4 + 1;
                                }
                                else {
                                    self.showIncorrectMessage = false;
                                    self.showNotFindMessage = false;
                                    self.showNotFindContacts = false;
                                    self.activeStep5 = true;
                                    self.stepActive(5);
                                }
                            }
                            else {
                                console.log('Не найдено контактов на ЛС');
                                self.showIncorrectMessage = true;
                                self.activeStep5 = false;
                                self.deActiveSteps(5);
                                self.failedAttempts4 = self.failedAttempts4 + 1;
                            }
                        }
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {
                    });
            },


            streetId() {
                if ($("#streets").val() != undefined && $("#streets").val() != '') {
                    this.selectedSreetGuid = $("#streets").val();
                    this.selectedSreetName = $('#streets option:selected').text();
                    return $("#streets").val();
                }
                return undefined;
            },
            houseId() {
                if ($("#houses").val() != undefined && $("#houses").val() != '') {
                    this.selectedHouseGuid = $("#houses").val();
                    vthis.selectedHouseName = $('#houses option:selected').text();
                    return $("#houses").val();
                }
                return undefined;
            },

            getHousesByStreet: function () {
                self = this;
                var ctrl = $("#houses");

                ctrl.empty();
                var o = $("<option disabled>нет домов для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");

                if (self.streetId() == undefined) {
                    return;
                }

                axios
                    .get("/Profiles/GetHouses/?guid=" + self.streetId())
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data.data;
                          //  console.info("data", data);
                            if (data.length > 0) {
                                ctrl.empty();
                                var o = $("<option value=''>выберите дом</option>");
                                o.appendTo(ctrl);
                            }
                            for (var i = 0; i < data.length; i++) {
                                var o = $("<option/>", {
                                    value: data[i].guid, text: data[i].name
                                });
                                o.appendTo(ctrl);
                            }
                            ctrl.selectpicker("refresh");
                            self.changeItemHouse();
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                    });
            },

            getStreetsByCity: function () {
                self = this;
                var ctrl = $("#streets");

                ctrl.empty();
                var o = $("<option disabled>нет улиц для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");

                if (this.cityGuid == undefined || this.cityGuid == "") {
                    return;
                }

                axios
                    .get("/Profiles/GetStreets/?guid=" + self.cityGuid)
                    .then(function (response) {
                        console.info("response", response);
                        if (response.status == 200) {
                            //если валидация на сервере успешная
                            var data = response.data.data;
                          //  console.info("data-streets", data);
                            if (data.length > 0) {
                                ctrl.empty();
                                var o = $("<option value=''>выберите улицу</option>");
                                o.appendTo(ctrl);
                            }

                            for (var i = 0; i < data.length; i++) {
                                var o = $("<option/>", { value: data[i].guid, text: data[i].name });
                                // o.attr("bspId", data[i].bspId);
                                o.appendTo(ctrl);
                            }
                            ctrl.selectpicker("refresh");
                            self.changeItemStreet();
                        }
                        //// возможно валидация на сервере прошла не успешно
                        else if (response.data.validationErrors !== null) {
                        } //или какая то другая ошибка
                        else {
                        }
                    })
                    .catch(function (error) {
                        if (error.response) {
                            console.log(error.response.data);
                            console.log(error.response.status);
                        } else if (error.request) {
                            console.log(error.request);
                        } else {
                            console.log("Error", error.message);
                        }
                        console.log(error.config);
                    });

            },

            getFiasGuidByCityId: function (cityId) {
                var fiasGuid = "9b968c73-f4d4-4012-8da8-3dacd4d4c1bd"
                switch (cityId) {
                    case 1:
                        fiasGuid = "8dea00e3-9aab-4d8e-887c-ef2aaa546456";
                        break;
                    case 2:
                        fiasGuid = "9b968c73-f4d4-4012-8da8-3dacd4d4c1bd";
                        break;
                    case 3:
                        fiasGuid = "94bb19a3-c1fa-410b-8651-ac1bf7c050cd";
                        break;
                    case 4:
                        fiasGuid = "42a02e11-a337-4d50-8596-fc76dae7c62a";
                        break;
                    case 5:
                        fiasGuid = "1346744e-8a64-4712-8939-bb84a1692874";
                        break;
                    case 6:
                        fiasGuid = "75917770-c4cb-44d8-afcc-8a6d395c3bc2";
                        break;
                    case 7:
                        fiasGuid = "5cfaf0c0-8f59-4321-9a5b-4b1c51b3779f";
                        break;
                    case 8:
                        fiasGuid = "ab0a1754-5ba1-48bb-8960-475c7fbc9feb";
                        break;
                    case 9:
                        fiasGuid = "d13945a8-7017-46ab-b1e6-ede1e89317ad";
                        break;
                    case 10:
                        fiasGuid = "52f876f6-cb1d-4f23-a22f-b692609fc1e0";
                        break;
                    case 11:
                        fiasGuid = "1b70e712-092e-4c45-9984-af3a2c7cfdd7";
                        break;
                    case 12:
                        fiasGuid = "070a8e7b-038f-48c8-9eed-16a6c03ab899";
                        break;
                    case 13:
                        fiasGuid = "b28b6f6f-1435-444e-95a6-68c499b0d27a";
                        break;
                    case 14:
                        fiasGuid = "65db5c88-c65c-43f0-9c21-13e15a032d4a";
                        break;
                    case 20:
                        fiasGuid = "2e3ec6d8-3835-4c57-9fbc-7e61b58a03a3";
                        break;
                    case 24:
                        fiasGuid = "2e1eaa1e-af75-47ee-bf79-5cd6c8183eb9";
                        break;
                    case 25:
                        fiasGuid = "8df8c56f-a46e-438f-a85b-a9b18ad4fc77";
                        break;
                    case 26:
                        fiasGuid = "01cc7377-a3a7-4793-9c77-52e3ef66a6ff";
                        break;
                    case 45:
                        fiasGuid = "d60b0309-b7d6-4e81-8424-af3f7136b28a";
                        break;
                    default:
                        fiasGuid = "9b968c73-f4d4-4012-8da8-3dacd4d4c1bd";
                        break;
                }
                return fiasGuid;
                /*
    1	Новосибирск  8dea00e3-9aab-4d8e-887c-ef2aaa546456
    2	Красноярск 9b968c73-f4d4-4012-8da8-3dacd4d4c1bd
    3	Кемерово 94bb19a3-c1fa-410b-8651-ac1bf7c050cd
    4	Абакан  42a02e11-a337-4d50-8596-fc76dae7c62a
    5	Белово 1346744e-8a64-4712-8939-bb84a1692874
    6	Канск 75917770-c4cb-44d8-afcc-8a6d395c3bc2
    7	Минусинск 5cfaf0c0-8f59-4321-9a5b-4b1c51b3779f
    8	Назарово ab0a1754-5ba1-48bb-8960-475c7fbc9feb
    9	Барнаул d13945a8-7017-46ab-b1e6-ede1e89317ad
    10	Бийск 52f876f6-cb1d-4f23-a22f-b692609fc1e0
    11	Куйбышев 1b70e712-092e-4c45-9984-af3a2c7cfdd7
    12	Мыски 070a8e7b-038f-48c8-9eed-16a6c03ab899
    13	Новокузнецк b28b6f6f-1435-444e-95a6-68c499b0d27a
    14	Рубцовск 65db5c88-c65c-43f0-9c21-13e15a032d4a
    20	Черногорск 2e3ec6d8-3835-4c57-9fbc-7e61b58a03a3
    24	Лучегорск 2e1eaa1e-af75-47ee-bf79-5cd6c8183eb9
    25	Кызыл 8df8c56f-a46e-438f-a85b-a9b18ad4fc77
    26	Ковдор 01cc7377-a3a7-4793-9c77-52e3ef66a6ff
    45	Рефтинский d60b0309-b7d6-4e81-8424-af3f7136b28a
                */
            }
            ,

            checkInnButtonAction: function () {
                this.showIncorrectMessage = false;
                this.showNotFindMessage = false;
                this.showNotFindContacts = false;
                var findButton = document.getElementById('checkInnButton');
                if (findButton != undefined) {
                    $(findButton).addClass('is-disable');
                    if (this.inputContragentInn.length > 9) $(findButton).removeClass('is-disable');
                }
            },


            checkVerifyCodeButtonAction: function () {
                this.showIncorrectMessage = false;
                this.showNotFindMessage = false;
                this.showNotFindContacts = false;
                var checkButton = document.getElementById('checkVerifyCodeButton');
                if (checkButton != undefined) {
                    $(checkButton).addClass('is-disable');
                    if (this.inputCode.length > 2) $(checkButton).removeClass('is-disable');
                }
            },

            stepActive: function (step) {
                var stepId = document.getElementById('adding_entity_step_' + step);
                if (stepId != undefined) {
                    stepId.style.display = 'block';
                    $(stepId).addClass('active');
                }

                var stepLinkId = document.getElementById('step' + step);
                if (stepLinkId != undefined) {
                    $(stepLinkId).addClass('password-recovery__steps-item--active');
                }
            },

            stepShow: function (step) {
                var stepId = document.getElementById('adding_entity_step_' + step);
                if (stepId != undefined) {
                    stepId.style.display = 'block';
                    $(stepId).addClass('active');
                }
            },

            stepHide: function (step) {
                var stepId = document.getElementById('adding_entity_step_' + step);
                if (stepId != undefined) {
                    stepId.style.display = 'none';
                    //$(stepId).addClass('active');
                }
            },

            stepDeActive: function (step) {
                var stepId = document.getElementById('adding_entity_step_' + step);
                if (stepId != undefined) {
                    stepId.style.display = 'none';
                    if (step == 2) {
                        this.inputContragentInn = "";
                    }
                    if (step == 3) {
                        this.selectedSreetGuid = "";
                        this.selectedSreetName = "";
                        var ctrls = $("#streets");
                        ctrls.empty();
                        this.selectedHouseGuid = "";
                        this.selectedHouseName = "";
                        var ctrlh = $("#houses");
                        ctrlh.empty();
                    }
                    if (step == 4) {
                        this.findEmail = "";
                        this.findPhone = "";
						//this.findEmail1 = "";
      //                  this.findPhone1 = "";
						this.findEmailHide = "";
						this.findPhoneHide = "";
                        this.checkFindPhone = false;
                        this.checkFindEmail = false;
                        this.contacts = { phone: "", email: "", legalAccountPhones: [], legalAccountEmails: [] };
                    }
                    if (step == 5) {
                        this.inputCapchaCode = "";
                        this.checkCapchaCode = false;
                        this.capchaError = "";
                    }
                    if (step == 6) {
                        this.inputCode = "";
                        this.phoneCode = "";
                        this.emailCode = "";
                        this.isPhoneVerified = 0;
                        this.isEmailVerified = 0;
                    }
                }
                var stepLinkId = document.getElementById('step' + step);
                if (stepLinkId != undefined) $(stepLinkId).removeClass('password-recovery__steps-item--active');
            },

            hideInput: function (id) {
                var input = document.getElementById(id);
                if (input != undefined) {
                    input.style.display = 'none';
                }
            },

            showInput: function (id) {
                var input = document.getElementById(id);
                if (input != undefined) {
                    input.style.display = 'block';
                }
            },

            errorInput: function (id) {
                var input = document.getElementById(id);
                if (input != undefined) {
                    $(input).addClass('is-error');
                }
            },

            noErrorInput: function (id) {
                var input = document.getElementById(id);
                if (input != undefined) {
                    $(input).removeClass('is-error');
                }
            },

            errorAccount: function () {
                this.errorInput('inputAccount');
            },
            errorInn: function () {
                this.errorInput('inputINN');
            },
            errorAddress: function () {
                this.errorInput('streets');
                this.errorInput('houses');
            },
            errorContacts: function () {
                this.errorInput('checkPhone');
                this.errorInput('checkEmail');
            },
            errorCaptcha: function () {
                this.errorInput('checkCaptcha');
            },
            errorCode: function () {
                this.errorInput('inputVerifyCode');
            },

            hideCode: function () {
                this.hideInput('inputVerifyCode');
            },
            showCode: function () {
                this.showInput('inputVerifyCode');
            },

            noErrorAccount: function () {
                this.noErrorInput('inputAccount');
            },
            noErrorInn: function () {
                this.noErrorInput('inputINN');
            },
            noErrorAddress: function () {
                this.noErrorInput('streets');
                this.noErrorInput('houses');
            },
            noErrorContacts: function () {
                this.noErrorInput('checkPhone');
                this.noErrorInput('checkEmail');
            },
            noErrorCaptcha: function () {
                this.noErrorInput('checkCaptcha');
            },
            noErrorCode: function () {
                this.noErrorInput('inputVerifyCode');
            },

            deActiveSteps: function (fromstep) {
                for (var i = fromstep; i <= 6; i++) {
                    this.stepDeActive(i);
                }
            },

            checkInn: function () {
                this.showIncorrectMessage = false;
                this.showNotFindMessage = false;
                this.showNotFindContacts = false;
                if (this.findContragentInn == this.inputContragentInn) {
                    console.log('Найденный ИНН и введенный равны');
                    this.findAddresses();
                    this.activeStep3 = true;
                    this.stepActive(3);
                    this.cityGuid = this.getFiasGuidByCityId(this.cityId);
                    this.noErrorInn();
                    this.stepHide(2);
                    this.getStreetsByCity();
                }
                else {
                    console.log('Найденный ИНН и введенный не совпадают');
                    this.activeStep3 = false;
                    this.showIncorrectMessage = true;
                    this.deActiveSteps(3);
                    this.failedAttempts2 = this.failedAttempts2 + 1;
                    this.errorInn();
                }
            },

            findAccounts: function () {
                var self = this

                self.responseStatus = false
                self.responseError = ''
                self.accounts = []

                axios.post('/Profiles/FindAccountsByCityAndAccountNumber', {
                    CityId: self.cityId,
                    AccountNumber: self.inputAccountNumber,
                })
                    .then(function (response) {
                        self.responseStatus = response.data.success;
                        self.responseError = response.data.responseError;

                        if (response.data.success) {
                            self.accounts = response.data.data
                            //console.log(self.accounts);
                            if (self.accounts.length > 0) {
                                self.findContragentInn = self.accounts[0].contragentInn;
                              //  console.log('Найденный ИНН: ' + self.findContragentInn);
                                self.findPhone1 = self.accounts[0].contragentPhone;
                                self.findEmail1 = self.accounts[0].contragentEmail;
                              //  console.log('Найденный телефон: ' + self.findPhone1);
                              //  console.log('Найденный емэйл: ' + self.findEmail1);
                                self.showNotFindMessage = false;
                                self.showIncorrectMessage = false;
                                self.showNotFindContacts = false;
                                self.activeStep2 = true;
                                self.stepActive(2);
                                self.noErrorAccount();
                            }
                            else {
                                self.showNotFindMessage = true;
                                self.deActiveSteps(2);
                                self.failedAttempts1 = self.failedAttempts1 + 1;
                                self.errorAccount();
                            }
                        }
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {
                    });
            },

            findAddresses: function () {
                var self = this

                self.isChecking = true
                self.responseStatus = false
                self.responseError = ''
                self.addresses = []

                axios.post('/Profiles/FindAccountsAddresses', {
                    DatabaseId: self.accounts[0].databaseId,
                    DivisionId: self.accounts[0].divisionId,
                    AccountId: self.accounts[0].accountId,
                    AccountNumber: self.accounts[0].accountNumber,
                    SAPDatabaseId: self.accounts[0].sapDatabaseId,
                    SAPDivisionId: self.accounts[0].sapDivisionId,
                    SAPAccountId: self.accounts[0].sapAccountId,
                    SAPAccountNumber: self.accounts[0].sapAccountNumber
                })
                    .then(function (response) {
                        self.responseStatus = response.data.success;
                        self.responseError = response.data.responseError;

                        if (response.data.success) {
                            self.addresses = response.data.data
                          //  console.log(self.addresses);
                        //    console.log(self.addresses.legalAccountAdresses);

                            if (self.addresses.legalAccountAdresses.length > 0) {
                                //self.findContragentInn = self.accounts[0].contragentInn;
                              //  console.log('Найденные адреса на ЛС: ' + self.addresses.legalAccountAdresses);
                                self.showIncorrectMessage = false;
                                self.showNotFindMessage = false;
                                self.showNotFindContacts = false;
                                //self.activeStep2 = true;
                                //self.stepActive(2);
                            }
                            else {
                                console.log('Не найдено адресов на ЛС');
                                self.showIncorrectMessage = true;
                                //self.deActiveSteps(3);
                            }
                        }
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {
                    });
            },


            verifyPhoneStart: function (event) {
                event.stopPropagation();

                if (this.findPhone == null) {
                    return;
                }

                // this.findPhone = "79513867720";

                const self = this;

                //const image = document.querySelector('.js-capcha-image');
                //const okbut = document.querySelector('.js-capcha-next-trigger');
                //okbut.style.display = 'none';

                //var code = self.captchacode;
                //self.captchacode = '';

                console.log("verifyPhoneStart");
                // $("#phone").attr('disabled', 'disabled');
                self.phoneVerifyError = '';
                self.isPhoneVerified = 0;
                self.phoneCode = '';
                self.inputCode = "";
                //var tvalue = $('input[name="__RequestVerificationToken"]').val();
                //let axiosConfig = {
                //    headers: { 'RequestVerificationToken': tvalue }
                //};
                //const data = {
                //};
              //  console.info(self.findPhone);

                //const showCapchaTrigger = document.querySelector('.js-capcha-show-trigger');
                //const showCapchaContainer = document.querySelector('.js-code-inner');

                // var count = this.getRandomInt(0, 100);

                axios.post('/Profiles/SendRequestPhoneVerify/' + self.findPhone/*, data, axiosConfig*/)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            console.log("verifyPhoneStart: отправка успешная");
                            //                     const showTimer = document.querySelectorAll('.js-timer');
                            //                     $(showTimer).addClass('is-show');
                            //const container = $('.js-timer-container');
                            //                     const poisonCode = container.find('.js-poison-code')
                            //                     const poisonCodeAgain = container.find('.js-poison-code-again');
                            //                     //const connectEdm = container.find('.js-connect-edm');
                            //                     //const inputCode = container.find('.js-input-code');
                            //const timer = container.find('.js-timer')[0];
                            //                     console.log("Poison Code", poisonCode);
                            //                     if (poisonCode.length > 0) {
                            //                         poisonCode.hide();
                            //                         poisonCodeAgain.hide();
                            //                         //if (connectEdm) connectEdm.show();
                            //                         //if (inputCode) inputCode.show();
                            //                         playTimer(timer);
                            //                         self.checkTimer(poisonCodeAgain, self.verifyPhoneAgain);
                            //                     };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.phoneVerifyError = response.data.message.join('');
                            console.log("verifyPhoneStart: отправка неуспешная");

                            //$("#phone").prop('disabled', '');
                            //var str = '<img src="/Captcha/Index/' + count + '">';
                            //$("#captcha1").html(str);
                            //showCapchaTrigger.style.display = '';
                            //showCapchaContainer.style.display = 'none';
                            //image.style.display = '';
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
                        console.log("verifyPhoneStart: Верификация телефона невозможна, попробуйте позже");

                        //$("#phone").prop('disabled', '');

                        //var str = '<img src="/Captcha/Index/' + count + '">';
                        //$("#captcha1").html(str);
                        //showCapchaTrigger.style.display = '';
                        //showCapchaContainer.style.display = 'none';
                        //image.style.display = '';
                    });
            },

            checkTimer(timer, fn) {
                var timerInterval = null;
                timerInterval = setInterval(function () {
                    if (timer.css('display') != 'none') {
                        fn();
                        clearInterval(timerInterval);
                    }
                }, 2000);
            },

            countdown: function () {
                var self = this;
                setTimeout(function () {
                    self.counter--;
                    self.countdown();

                },
                    1000);
            },
            //verifyPhoneAgain() {
            //    $("#phone").prop('disabled', '');
            //},

            verifyEmailStart: function (event) {
                event.stopPropagation();
                if (this.findEmail == '') {
                    return;
                }

                const self = this;
                //	this.findEmail = "PertsevAN@digtp.com";

                console.log("verifyEmailStart");

                // $("#email").attr('disabled', 'disabled');
                self.emailVerifyError = '';
                self.isEmailVerified = 0;
                self.emailCode = '';
                self.inputCode = "";

                //const showCapchaTrigger = document.querySelector('.js-capcha-show-trigger-email');
                //const showCodeInner = document.querySelector('.js-code-inner-email');

                //showCapchaTrigger.style.display = 'none';
                //showCodeInner.style.display = '';
                //const showTimer = document.querySelector('.js-timer-email');
                //$(showTimer).addClass('is-show');

                axios.post('/Profiles/SendRequestEmailVerify/' + formId + '/' + self.findEmail)
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            //const container = $('.js-timer-container.email');
                            //const poisonCode = container.find('.js-poison-code')
                            //const poisonCodeAgain = container.find('.js-poison-code-again');
                            //const connectEdm = container.find('.js-connect-edm');
                            //const inputCode = container.find('.js-input-code');
                            //const timer = container.find('.js-timer')[0];
                            //self.counter = self.lifeTimeRestoreCode;
                            console.log("verifyEmailStart: отправка успешная");

                            self.countdown();
                            if (poisonCode.length > 0) {

                                //poisonCode.hide();
                                //poisonCodeAgain.hide();
                                //if (connectEdm) connectEdm.show();
                                //if (inputCode) inputCode.show();
                                //playTimer(timer);
                                //self.checkTimer(poisonCodeAgain, self.verifyEmailAgain);
                            };
                        }
                        if (!response.data.isSuccess) {
                            self.isValidateErrors = true;
                            self.isServerVerify = false;
                            self.emailVerifyError = response.data.message.join('');
                            console.log("verifyEmailStart: отправка неуспешная");

                            //$("#email").prop('disabled', '');
                            //showCapchaTrigger.style.display = '';
                            //showCodeInner.style.display = 'none';

                            //axios.get('/Captcha/Index')
                            //    .then(function (response) {
                            //        showCapchaTrigger.style.display = '';
                            //        showCapchaContainer.style.display = 'none';
                            //    })
                        }

                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.emailVerifyError = 'Верификация email невозможна, попробуйте позже';
                        console.log("verifyEmailStart: Верификация email невозможна, попробуйте позже");

                        // $("#email").prop('disabled', '');
                    });

                event.stopPropagation();
            },

            //verifyEmailAgain() {
            //    $("#email").prop('disabled', '');
            //},

            verifyPhoneCode: async function () {
                var self = this;
                this.isValidateErrors = false;
                //	this.findPhone = "79513867720";
                console.log("verifyPhoneCode");

                return await axios.post('/Profiles/VerifyCode', {
                    Phone: self.findPhone,
                    VerificationCode: self.phoneCode
                })
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            self.phoneVerifyError = '';
                            console.log("verifyPhoneCode: верификация успешная");
                            self.noErrorCode();
                            self.hideCode();
                        }
                        else {
                            self.phoneVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                            console.log("verifyPhoneCode: верификация неуспешная");
                            self.errorCode();
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        console.log("verifyPhoneCode: верификация неуспешная");
                        return false;
                    });
            },
            verifyEmailCode: async function () {
                var self = this;
                this.isValidateErrors = false;

                //this.findEmail = "PertsevAN@digtp.com";

                console.log("verifyEmailCode");

                return await axios.post('/Profiles/VerifyCode', {
                    Login: formId,
                    Email: self.findEmail,
                    VerificationCode: self.emailCode
                })
                    .then(function (response) {
                        if (response.data.isSuccess) {
                            self.emailVerifyError = '';
                            console.log("verifyEmailCode: верификация успешная");
                            self.noErrorCode();
                            self.hideCode();
                        }
                        else {
                            self.emailVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
                            console.log("verifyEmailCode: верификация неуспешная");
                            self.errorCode();
                        }
                        return response.data.isSuccess;
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        console.log("verifyEmailCode: верификация неуспешная");
                        return false;
                    });
            },
            verifyEmailCheckCode: async function (event) {

                event.stopPropagation();
                this.isEmailVerified = 0;

                if (this.emailCode == '') {
                    return;
                }

                //	const showCapchaContainer = document.querySelector('.js-code-inner-email');
                //const container = $('.js-timer-container.email');
                //const poisonCode = container.find('.js-poison-code')
                //const poisonCodeAgain = container.find('.js-poison-code-again');
                //const connectEdm = container.find('.js-connect-edm');
                //	const inputCode = container.find('.js-input-code');
                //	const timer = container.find('.js-timer');

                //showCapchaContainer.style.display = 'none';
                if (await this.verifyEmailCode()) {
                    this.isEmailVerified = 1;
                    //inputCode.hide();
					this.stepHide(3);
                    this.stepHide(5);
					this.stepHide(6);
                }
                else {
                    //$("#phone").prop("disabled", false);
                    this.isEmailVerified = -1;
                }
            },

            getWayOfVerify: function () {
                var result = 0;//нет ни телефона ни емэйла -невозможно верификацию провести
                if (this.checkFindPhone == true && this.findPhone != "") {
                    result = 1;//через телефон
                }
                if (this.checkFindEmail == true && this.findEmail != "") {
                    result = 2;//через емэйл
                }
                if (this.checkFindPhone == false && this.checkFindEmail == false) {
                    if (this.findPhone != "") {
                        result = 1;//через телефон
                    }
                    else {
                        if (this.findEmail != "") {
                            result = 2;//через емэйл
                        }
                    }
                }
                return result;
            },

            verifyStart: function (event) {
                if (this.getWayOfVerify() == 1) {
                    this.verifyPhoneStart(event);
                }

                if (this.getWayOfVerify() == 2) {
                    this.verifyEmailStart(event);
                }
            },

            verifyCheckCode: async function (event) {
                if (this.getWayOfVerify() == 1) {
                    this.phoneCode = this.inputCode;
                    this.showCode();
                    await this.verifyPhoneCheckCode(event);
                }
                if (this.getWayOfVerify() == 2) {
                    this.emailCode = this.inputCode;
                    this.showCode();
                    await this.verifyEmailCheckCode(event);
                }
            },

            verifyPhoneCheckCode: async function (event) {

                event.stopPropagation();
                this.isPhoneVerified = 0;
                //const showCapchaContainer = document.querySelector('.js-code-inner');

                if (this.phoneCode == '') {
                    return;
                }

                //const container = $('.js-timer-container.phone');
                //const poisonCode = container.find('.js-poison-code')
                //const poisonCodeAgain = container.find('.js-poison-code-again');
                //const connectEdm = container.find('.js-connect-edm');
                //const inputCode = container.find('.js-input-code');
                //const timer = container.find('.js-timer');

                var v = await this.verifyPhoneCode();
                //showCapchaContainer.style.display = 'none';

                if (v) {
                    this.isPhoneVerified = 1;
                    ///inputCode.hide();
					this.stepHide(3);
					this.stepHide(5);
					this.stepHide(6);
                }
                else {
                    this.isPhoneVerified = -1;

                }

            },

            addAccount: function () {
                var self = this

                if (self.accounts.length > 0) {
                    self.accountForAdd = self.accounts[0];
                }

                axios.post('/Profiles/AddLegalAccountByUser', self.accountForAdd)
                    .then(function (response) {
                        document.location.href = '/'
                    })
                    .catch(function (error) {
                    })
                    .finally(function () {
                    });
            },

            setSelectpicker: function () {
				$('#streets').selectpicker({
					noneResultsText: 'Совпадений не найдено'
                });
				$('#houses').selectpicker({
					noneResultsText: 'Совпадений не найдено'
				});
            }
        },

        mounted() {
            this.Cities = JSON.parse(this.cities);
            this.showUL();
            this.setSelectpicker();
        },

        created: function () {
        },
    }

</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/AddEntityNew.vue